// @ts-check
import React, { useState } from 'react';
import store from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, Grid, makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Accordion from '../../custom/Accordion';
import AccordionSummary from '../../custom/AccordionSummary';
import AccordionDetails from '../../custom/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import clsx from 'clsx';
import useFormStyles from '../../common/FormStyle';
import SimpleTextInput from '../common/SimpleTextInput'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import {
  SET_BUILDING_TYPE,
  SET_FLOOR_HEIGHT,
  SET_ROAD_WIDTH,
  SET_DISTANCE_FROM_ROAD,
  SET_FLOORS_NUMBER,
  SET_PERPENDICULAR_FLOORS_NUMBER,
  SET_CORRIDOR_WIDTH,
  SET_FLAT_DEPTH,
  SET_DISTANCE_BETWEEN_VERTICAL_CORES,
  INPUT_CHANGED,
  SET_MINIMAL_BLOCK_DEPTH,
  SET_MINIMAL_BLOCK_WIDTH
} from '../../../redux/actions/actionTypes'

// Images
import O_png from '../../../assets/buildingTypes/O-type.jpg';
import I_png from '../../../assets/buildingTypes/I-type.jpg';
import L_png from '../../../assets/buildingTypes/L-type.jpg';
import H_png from '../../../assets/buildingTypes/H-type.jpg';
import T_png from '../../../assets/buildingTypes/T-type.jpg';
import D_png from '../../../assets/buildingTypes/D-type.jpg';


// Tabs
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';

import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import ViewAgendaIcon from '@material-ui/icons/ViewAgenda';
import CloseIcon from '@material-ui/icons/Close';

const useBuildingStyles = makeStyles((theme) => ({
  // Building types button
  buildingTypes: {
    height: "70px",
    flexGrow: 1,
    flexBasis: 0,
    backgroundColor: "#fff",
    cursor: "pointer",
    padding: theme.spacing(2),
    '&:hover': {
      backgroundColor: "rgba(0,0,0,.15)"
    },
    border: "1px solid #000",
    transition: "all 150ms ease-in-out",
    position: "relative",
    display: "flex",
    justifyContent: "center"
  },
  buildingTypeActive: {
    backgroundColor: "rgba(0,0,0,.25)",
    '&:hover': {
      backgroundColor: "rgba(0,0,0,.25)",
    }
  },
  buildingImage: {
    height: "100%",
    margin: "0",
    position: "absolute",
    top: "0"
  },
  // Input style
  additionalInput: {
    width: "25%"
  },
  pushRight: {
    marginLeft: 'auto'
  },
  root: {
    flexGrow: 1,
    width: '100%',
  },
}))

// Building types array
const buildingTypes = [
  {
    type: 1,
    value: "I",
    png: I_png,
    tab: 0
  },
  {
    type: 4,
    value: "H",
    png: H_png,
    tab: 1
  }
]

/* 
    The building info section of the form
    This component will already be inside a <form></form> tag
*/
function BuildingInfo(props) {
  const formStyles = useFormStyles();
  const classes = useBuildingStyles();


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const buildingStyles = useBuildingStyles();

  const dispatch = useDispatch()
  const rootState = useSelector(state => state);
  const validationState = useSelector(state => state.globalFormData.validation);
  const buildingInfoState = useSelector(state => state.globalFormData.buildingInfo);
  const units = useSelector(state => state.globalFormData.buildingInfo.units);

  const house_plot_size_error = () => {
    if (units == 'm') {
      return validationState?.house_plot_size?.errText
    } else {
      return validationState?.house_plot_size?.errTextFt
    }
  }
  const floor_height_error = () => {
    if (units == 'm') {
      return validationState?.floor_height?.errText
    } else {
      return validationState?.floor_height?.errTextFt
    }
  }
  const road_width_error = () => {
    if (units == 'm') {
      return validationState?.road_width?.errText
    } else {
      return validationState?.road_width?.errTextFt
    }
  }
  const distance_from_road_error = () => {
    if (units == 'm') {
      return validationState?.distance_from_road?.errText
    } else {
      return validationState?.distance_from_road?.errTextFt
    }
  }

  const buildingType = buildingInfoState.building_type

  const [value, setValue] = React.useState(buildingType == 'I' ? 0 : 1);


  // Global form data
  const { floor_height, total_building_width, flat_depth, changeFormDataDispatch } = props;
  // Localise global state form data
  const [formData, setFormData] = useState({
    floor_height: floor_height,
    total_building_width: total_building_width
  });

  // Expansion/ Collapse
  const [expanded, setExpanded] = useState(false);
  const handleExpanded = () => {
    setExpanded(!expanded);
  };
  return (
    <Accordion expanded={expanded} onChange={handleExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon fontSize="small" />}
        aria-controls="buildingInfo-content"
        id="buildingInfo-header"
        IconButtonProps={{
          className: formStyles.expandButton
        }}
      >
        <Typography className={clsx(formStyles.accordionSubheader, formStyles.bold)}>Building</Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Grid container>


          <Paper square className={classes.root}>
            <Tabs
              value={buildingType == "I" ? 0 : 1}
              onChange={handleChange}
              variant="fullWidth"
              indicatorColor="primary"
              textColor="primary"
              aria-label="icon tabs example"
            >
              <Tab aria-label="phone"
                icon={<Avatar alt="test avatar" src={I_png} />}
                onClick={(event) => {
                  setValue(0);
                  dispatch({
                    type: SET_BUILDING_TYPE,
                    payload: "I"
                  })
                  // setTimeout(() => {
                  // const newState = store.getState()
                  // dispatch({
                  //   type: INPUT_CHANGED,
                  //   payload: {
                  //     rootState: newState
                  //   }
                  // })
                  // }, 0)
                }}
              />
              <Tab icon={<Avatar alt="test avatar" src={H_png} />}
                aria-label="ViewComfyIcon"
                onClick={(event) => {
                  setValue(1);
                  dispatch({
                    type: SET_BUILDING_TYPE,
                    payload: "H"
                  })
                  // setTimeout(() => {
                  // const newState = store.getState()
                  // dispatch({
                  //   type: INPUT_CHANGED,
                  //   payload: {
                  //     rootState: newState
                  //   }
                  // }
                  // )
                  // }, 0)
                }
                }
              />
            </Tabs>
          </Paper>

          <TabPanel className={formStyles.w100} value={value} index={0}>
            <SimpleTextInput label="Number of floors" name="num_of_storeys_buildings" suf=' '
              type="number"
              error={!validationState.floors_number.valid}
              helperText={!validationState.floors_number.valid && validationState.floors_number.errText}
              value={buildingInfoState.floors_number}
              placeHolder='e.g. 5'
              onChange={(event) => {
                dispatch({
                  type: SET_FLOORS_NUMBER,
                  payload: parseInt(event.target.value)
                })
              }}
              onBlur={(event) => {
                dispatch({
                  type: INPUT_CHANGED,
                  payload: {
                    rootState
                  }
                })
              }}
            />
            <SimpleTextInput label="Floor height" name="floor_height" type="number" suf={`(${units})`}
              error={!validationState.floor_height.valid}
              helperText={
                !validationState.floor_height.valid && floor_height_error()
              }
              value={buildingInfoState.floor_height}
              placeHolder='e.g. 3.2'
              onChange={(event) => {
                dispatch({
                  type: SET_FLOOR_HEIGHT,
                  payload: parseFloat(event.target.value)
                })
              }}
              onBlur={(event) => {
                dispatch({
                  type: INPUT_CHANGED,
                  payload: {
                    rootState
                  }
                })
              }}
            />



            <SimpleTextInput label="Distance between vertical cores - lifts / staircases"
              name="distance_between_vertical_cores" type="number" suf={`(${units})`}
              error={!validationState.distance_between_vertical_cores.valid}
              helperText={!validationState.distance_between_vertical_cores.valid && (units === 'm' ?
                validationState.distance_between_vertical_cores.errText : validationState.distance_between_vertical_cores.errTextFt)}
              value={buildingInfoState.distance_between_vertical_cores}
              placeHolder='e.g. 20'
              onChange={(event) => {
                dispatch({
                  type: SET_DISTANCE_BETWEEN_VERTICAL_CORES,
                  payload: parseFloat(event.target.value)
                })
              }}
              onBlur={(event) => {
                dispatch({
                  type: INPUT_CHANGED,
                  payload: {
                    rootState
                  }
                })
              }}
            />




          </TabPanel>

          <TabPanel className={formStyles.w100} value={value} index={1} >
            <>
              {/* Length x depth */}
              <Typography className={clsx(formStyles.accordionTitle, formStyles.bold)} component={'span'}>
                House plot size
              </Typography>
              <Box className={formStyles.w100}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >

                <SimpleTextInput
                  label=''
                  error={!validationState?.house_plot_size?.valid}
                  helperText={!validationState?.house_plot_size?.valid && house_plot_size_error()}
                  variant="outlined"
                  placeholder="e.g. 12"
                  suf={`(${units})`}
                  name="plot_length"
                  size="small"
                  type="number"
                  style={{
                    width: "40%"
                  }}
                  value={buildingInfoState.minimal_block_depth}
                  onChange={(event) => {
                    dispatch({
                      type: SET_MINIMAL_BLOCK_DEPTH,
                      payload: event.target.value
                    })
                  }}
                  onBlur={(event) => {
                    dispatch({
                      type: INPUT_CHANGED,
                      payload: {
                        rootState
                      }
                    })
                  }}

                  inputProps={{
                    className: formStyles.inputField
                  }}
                />
                <CloseIcon className={formStyles.margin2} />
                {/* Plot width */}
                <SimpleTextInput
                  label=''
                  error={!validationState?.house_plot_size?.valid}
                  helperText={!validationState?.house_plot_size?.valid && house_plot_size_error()}
                  variant="outlined"
                  placeholder="e.g.28"
                  suf={`(${units})`}
                  name="plot_width"
                  size="small"
                  type="number"
                  style={{
                    width: "40%"
                  }}
                  value={buildingInfoState.minimal_block_width}
                  onChange={(event) => {
                    dispatch({
                      type: SET_MINIMAL_BLOCK_WIDTH,
                      payload: event.target.value
                    })
                  }}
                  onBlur={(event) => {
                    dispatch({
                      type: INPUT_CHANGED,
                      payload: {
                        rootState
                      }
                    })
                  }}
                  inputProps={{
                    className: formStyles.inputField
                  }}
                />
              </Box>
              {
                !validationState?.house_plot_size_second?.valid &&
                <Typography style={{ color: 'Red' }}>
                  {validationState?.house_plot_size_second?.errText}
                </Typography>
              }


              <SimpleTextInput label="Floor height"
                name="floor_height" type="number" suf={`(${units})`}
                error={!validationState.floor_height.valid}
                helperText={!validationState.floor_height.valid && floor_height_error()}
                value={buildingInfoState.floor_height}
                placeHolder='e.g. 3.2'
                onChange={(event) => {
                  dispatch({
                    type: SET_FLOOR_HEIGHT,
                    payload: parseFloat(event.target.value)
                  })
                }}
                onBlur={(event) => {
                  dispatch({
                    type: INPUT_CHANGED,
                    payload: {
                      rootState
                    }
                  })
                }}
              />
              <SimpleTextInput label="Road Width" name="road_width" type="number" suf={`(${units})`} placeHolder='e.g. 7'
                error={!validationState.road_width?.valid}
                helperText={!validationState.road_width?.valid && road_width_error()}
                value={buildingInfoState.road_width}
                onChange={(event) => {
                  dispatch({
                    type: SET_ROAD_WIDTH,
                    payload: parseFloat(event.target.value)
                  })
                }}
                onBlur={(event) => {
                  dispatch({
                    type: INPUT_CHANGED,
                    payload: {
                      rootState
                    }
                  })
                }}
              />
              <SimpleTextInput label="Distance from road" name="distance_from_road" type="number" suf={`(${units})`} placeHolder='e.g. 4'
                error={!validationState.distance_from_road?.valid}
                helperText={!validationState.distance_from_road?.valid && distance_from_road_error()}
                value={buildingInfoState.distance_from_road}
                onChange={(event) => {
                  dispatch({
                    type: SET_DISTANCE_FROM_ROAD,
                    payload: parseFloat(event.target.value)
                  })
                }}
                onBlur={(event) => {
                  dispatch({
                    type: INPUT_CHANGED,
                    payload: {
                      rootState
                    }
                  })
                }}
              />

            </>
          </TabPanel>


        </Grid>
      </AccordionDetails>
    </Accordion>
  )
};

export default BuildingInfo;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div p={3}>
          <Typography component={'span'}>{children}</Typography>
        </div>
      )}
    </div>
  );
}
